/**
 * @memberof SMART2
 * @ngdoc directive
 * @name Tabs-control
 * @description This directive is useful for creating a tabs control.
 *
 * @attr {Array} tab-config
 *    Tabs config. Please see example for more.
 * @attr {String} width
 *    Width of tabs holder. Default value is '100%'.
 *
 * @example
 Tabs Config in default case
  $scope.tabsData = [{
 "title" : "Tab 1",
 "contentUrl" : "tab1.html",
 "active" : true
 }, {
 "title" : "Tab 2",
 "contentUrl" : "tab2.html"
 }, {
 "title" : "Tab 3",
 "contentUrl" : "tab3.html"
 }];
 
 *@example
 Controller in case default tab styling is to be overriden(set htmlmode=true and pass template url in tabsUrl):
 $scope.tabsData = [{
 "title" : "Tab 1",
 "contentUrl" : "tab1.html",
 "active" : true,
 "htmlmode":true,
 "tabsUrl":"template1.html"
 }, {
 "title" : "Tab 2",
 "contentUrl" : "tab2.html",
 "htmlmode":true,
 "tabsUrl":"template2.html"
 }, {
 "title" : "Tab 3",
 "contentUrl" : "tab3.html",
 "htmlmode":true,
 "tabsUrl":"template3.html"
 }];

 Usage:
 <smart-tabs tab-config="{{tabsData}}" width="60%" header-template="test_template.html"></smart-tabs>
 */

(function() {
	'use strict';
	var tabsId = 0;

	angular.module('SMART2').directive('smartTabs', ['$timeout','$parse',
	function ($timeout, $parse) {
		return {
			restrict : 'E',
			replace : true,
			scope: true,
			link: function (scope, element, attrs) {
			    var selectionCallback = $parse(attrs.onSelect),
				    tabWidth = attrs.width, 
					documentTabFocus = 0,
				documentTabList = null,
				    tabParent = element.find('.tabparent'),
				    currentTab;
			
			function documentTabKeyDownEvent(e){
			    var tabs = document.querySelectorAll('.tabparent-container [role="tab"] a');
			      tabs[documentTabFocus].setAttribute("tabindex", -1);
				 tabs[documentTabFocus].setAttribute("aria-selected", false);

			      if (e.keyCode === 39) { //ArrowRight
				documentTabFocus++;
				if (documentTabFocus >= tabs.length) {
				  documentTabFocus = 0;  
				}
			      e.preventDefault();
			      } else if (e.keyCode === 37) { //ArrowLeft
				documentTabFocus--;
				if (documentTabFocus < 0) { 
				  documentTabFocus = tabs.length - 1;
				}
			      e.preventDefault();
			      }
			      if (e.keyCode === 35) { //End
				documentTabFocus = tabs.length - 1;
				e.preventDefault();
			      }
			      else if (e.keyCode === 36) { //Home
				documentTabFocus = 0;
				e.preventDefault();
			      }
				tabs[documentTabFocus].setAttribute("tabindex", 0);
				if(e.keyCode == 13){ //Enter
					tabs[documentTabFocus].setAttribute("aria-selected", true);
					tabs[documentTabFocus].click();
				}else{
				      tabs[documentTabFocus].focus();
				}
			  }
				
			    scope.revisionMode = ((!attrs.revisionMode || attrs.revisionMode == "false") ? false : true);
				tabParent.css('width', tabWidth);
				var timeoutCanel = $timeout(function() {
					var tabs = element.find('.tabs');
					tabs.tabs();
					$timeout.cancel(timeoutCanel);
				});
				//scope.stickTabs = false;

				scope.vertical = attrs.vertical;
				scope.tabPanelHeight = angular.isDefined(attrs.tabPanelHeight) ? scope.vertical == 'true' ? attrs.tabPanelHeight : '100%' : '100%';

				//uniqueID
				tabsId = tabsId + 1;
				scope.tabId = "tab-" + tabsId;
				var tabWidthInFloat = parseFloat(tabWidth);
				var remainingWidth = (100 - tabWidthInFloat) + "%";
				//var rightHeaderStyle="{'background-color':'red';'width':"+remainingWidth+";'margin-left'}";
				scope.headerStyle = {
					"width" : remainingWidth,
					"margin-left" : tabWidth,
					"height" : '48px'
				};
				scope.headerTemplate = attrs.headerTemplate;
				attrs.$observe('tabConfig', function (value) {
				    scope.tabConfig = scope.$eval(value);
				    var activeTabContent = currentTab;
				     var item = _.find(scope.tabConfig, function (item) { return item.active == true; });
                    if (currentTab && currentTab.htmlmode && item == undefined) {
                        for (var i = 0; i < scope.tabConfig.length; i++) {
                            var tTab = scope.tabConfig[i];
                            if (tTab.title.toLowerCase() === activeTabContent.title.toLowerCase()) {
                                tTab.active = true;
                    		}	
			    		}
				    }
				    scope.tabConfig = _.each(scope.tabConfig, function(tab) {
                        var tmpId = '';
						if(tab.id){
							tmpId = "tab_" + tab.id;        
							var tmpElementCount = $('#' + tmpId).length;
							if(tmpElementCount > 0) {
								tmpId = tmpId + '_' + scope.tabId;
							}
						} else {
							tmpId = scope.tabId;
						}
						tab.uid = tmpId;
                        if(tab.active) {
                            currentTab = tab;
                        }
                    });
				    if (currentTab) {
				        currentTab.isLoaded = true;
				        scope.selectedTabContentUrl = currentTab.contentUrl;
				        //scope.tabClickCallback(currentTab);
				    }
					if(!documentTabList){
						documentTabList = document.querySelector('.tabparent-container .tabs[role="tablist"]');
						if(documentTabList){
							documentTabList.addEventListener("keydown", documentTabKeyDownEvent.bind(this));
						}
					}
					var cancelTimeOut = $timeout(function(){
						var items = document.querySelectorAll('.tabparent-container [role="tab"] a');
							if(items.forEach){ //its not array, its NodeList
								items.forEach(function(i, idx){
									if($(i).hasClass('active'))
									{
										documentTabFocus = idx;
									}
								});	
						}
						$timeout.cancel(cancelTimeOut);
					}, 5000);
				});

				//attrs.$observe('stickTabs', function (value) {
				//    scope.stickTabs = scope.$eval(value);
				//});

				//scope.$on('checkTabIsDirty', function (event, data) {
				//    currentTab.isTabValidate = scope[currentTab.onBeforeTabChange] && scope[currentTab.onBeforeTabChange]();
				//});

				scope.tabClickCallback = function (item) {
				    var returnObject = angular.copy(item);
				    returnObject.previousTab = currentTab;
				    returnObject.previousTab.active = false;
				    currentTab = item;
				    item.active = true;
				    item.isLoaded = true;
                    //returnObject.previousTab.isTabValidate = scope[returnObject.previousTab.onBeforeTabChange] && scope[returnObject.previousTab.onBeforeTabChange]();
				    if (angular.isFunction(selectionCallback)) {
				        selectionCallback(scope, { 'e': returnObject });
				    }
				    //TWO-6116  fixed.
				    //$timeout(function () {
				    //    scope.$broadcast('scrollTopToBottom', element.find('.scroll-container').outerHeight());
				    //}, 800);
				};
				scope.$on('$destroy', function () {
				    tabParent = null;
				    element.remove();
				    scope = null;
				});
			},
			templateUrl : 'shared/directives/uiElements/smartTabs/smartTabsTemplate.html'
		};
	}]);
})();
